function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import TwoThirdsTextAndAssetConfig from "segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-config";
import FullParagraphConfig from "segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-config";
import TagItemsGridConfig from "segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-config";
import FlexibleCardGridConfig from "segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-config";
import ThemeConfig from "segments/core-configs/theme-config";
export default {
    type: FIELD_TYPES.NESTED,
    label: "Personas",
    fields: _object_spread_props(_object_spread({}, ThemeConfig), {
        tabsColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Tabs color"
        },
        tabsBackgroundColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Tabs background color"
        },
        alignToLogo: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        },
        swapTagsWithTextAndAssets: {
            type: FIELD_TYPES.BOOLEAN,
            label: "Swap Tags with Text and Asset  (Temporary for test)"
        },
        tabs: {
            type: FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 6,
            nestedConfig: {
                type: FIELD_TYPES.NESTED,
                fields: {
                    tabLabel: {
                        type: FIELD_TYPES.TEXT,
                        label: "Tab Label",
                        translatable: true
                    },
                    tabId: {
                        type: FIELD_TYPES.TEXT,
                        label: "Tab Id"
                    },
                    timer: {
                        type: FIELD_TYPES.TEXT,
                        label: "Tab Timer Length (in milliseconds)"
                    },
                    textAndAssetTwoThirds: {
                        type: FIELD_TYPES.NESTED,
                        label: "Text and asset",
                        fields: _object_spread({
                            textAndAssetPaddingTop: {
                                type: FIELD_TYPES.TEXT,
                                label: "Padding top"
                            }
                        }, TwoThirdsTextAndAssetConfig.fields)
                    },
                    fullParagraph: {
                        type: FIELD_TYPES.NESTED,
                        label: "Full Paragraph",
                        fields: _object_spread({
                            fullParagraphPaddingTop: {
                                type: FIELD_TYPES.TEXT,
                                label: "Padding top"
                            }
                        }, FullParagraphConfig.fields)
                    },
                    tagItems: {
                        type: FIELD_TYPES.NESTED,
                        label: "Tag Items",
                        fields: _object_spread({
                            tagItemsPaddingTop: {
                                type: FIELD_TYPES.TEXT,
                                label: "Padding top"
                            }
                        }, TagItemsGridConfig.fields)
                    },
                    flexibleCards: {
                        type: FIELD_TYPES.NESTED,
                        label: "Flexible Cards",
                        fields: _object_spread({
                            flexibleCardsPaddingTop: {
                                type: FIELD_TYPES.TEXT,
                                label: "Padding top"
                            },
                            imagePaddingBottom: {
                                type: FIELD_TYPES.TEXT,
                                label: "Padding Bottom (under the image)"
                            }
                        }, FlexibleCardGridConfig.fields)
                    }
                }
            }
        }
    })
};
